import Data from './pcaa';
let options = [];
for (let key in Data['86']) {
    let citys = [];
    for (let keyc in Data[key]) {
        let areas = [];
        for (let keya in Data[keyc]) {
            let area = { value: keya, label: Data[keyc][keya] };
            areas.push(area);
        }
        let city = { value: keyc, label: Data[key][keyc], children: areas };
        citys.push(city);
    }
    let province = { value: key, label: Data['86'][key], children: citys };
    options.push(province);
}
export default options;
